import React, { createRef, useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import PrevArrow from "../../LearningPaths/PrevArrow";
import NextArrow from "../../LearningPaths/NextArrow";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getDateTime, SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import {
    getCrsReportOffices,
    getCrsReportRea,
    getCrsReportReaClear,
    getCrsReportStats,
    getCrsReportStatsClear,
    getCrsReportTrend,
    getCrsReportTrendClear,
    getCrsReportTrendOfSingle,
    getCrsReportTrendOfSingleClear
} from "../../../redux/reports/actions";
import _ from "lodash";
import ProgressReportTableComponent from "../progressReport/ProgressReportTableComponent";
import RealEstateAgentsReportSection from "./RealEstateAgentsReportSection";
import Loader from "../../Loader/Loader";
import PiechartProgressReport from "../New Progress Report/PiechartProgressReport";
import {
    getAnyTotalReportClear,
    getProfileCompletionReport,
    getProfileCompletionReportClear,
} from "../../../redux/reports/actions";

import CONFIG from "../../../utils/config";
import PieChartComponent from "../ReportsComponents/PieChartComponent";
import ReportTableSectionComp from "../ReportsComponents/ReportTableSectionComp";
import { useLocation, useNavigate } from "react-router-dom";
import ManagerReportSec from "../ReportsComponents/ManagerReportSec";
import OfficeSection from "../ReportsComponents/OfficeSection";
import CompletionTrendGraph from "../ReportsComponents/CompletionTrendGraph";
import { Spinner } from "react-bootstrap";
import ManagerReportCrs from '../New Progress Report/ManagerReportCrs';
import OfficesReportSection from "../New Progress Report/OfficesReportSection";

import CompletionTrendGraphNew from "../ReportsComponents/CompletionTrendGraphNew";
import DonutChart from "../../Layouts/Graphs/DonutChart";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import ChooseOfficePeople from "../../reportFilter/ChooseOfficePeople";
import ChooseProvider from "../../reportFilter/ChooseProvider";
import ChooseCourse from "../../reportFilter/ChooseCourse";
import ChooseManager from "../../reportFilter/ChooseManager";
import ChooseREA from "../../reportFilter/ChooseREA";
import { getTeamMatesResClear } from "../../../redux/assignCourse/actions";
import TrendChart from "../../../utils/TrendChart";
import TrendChartSingle from "../../../utils/TrendChartSingle";
import ReportGraphComponent from "../layout/ReportGraphComponent";
import ProgressReportTableComponentForAgentDetail from "../progressReport/ProgressReportTableComponentForAgentDetail";
import { userDetailBroker, userDetailOther } from "../../../redux/user/actions";
import StaticUtils from "../../../utils/StaticUtils";
import * as XLSX from "xlsx";
import AgentReportUICardComponent from "../layout/AgentReportUICardComponent";

const ComplianceReportSectionAgentDetail = (props) => {

    const {
        isMobile
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isCompliance = params.get("isCompliance");
    const idFrom = params.get("id");
    const from = params.get("from");
    const isVideos = params.get("isVideos");

    const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);

    const overAllSummaryCrsRes = useSelector(
        (state) => state.report.overallSummaryCrsData
    );
    const [overSummaryCrsData, setOverSummaryCrsData] = useState([]);
    const overAllDataRes = useSelector((state) => state.report.overallData);
    const overAllSummaryGraphRes = useSelector(
        (state) => state.report.overallSummaryCrsGraph
    );
    const [reaList, setReaList] = useState([])

    const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
    const [overAllLearningHours, setOverAllLearningHours] = useState([]);
    const [OverAllStatsData, setOverAllStatsData] = useState([]);
    const [isView, setIsView] = useState("table");
    const [type, setType] = useState("pie");
    const [canShow, setCanShow] = useState(false);
    const [isLoaded, setIsLoaded] = useState(true);
    const [limitStatus, setLimitStatus] = useState("")
    const [loadSpin, setLoadSpin] = useState(true)
    const [totalRea, setTotalRea] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [imgLoader, setImgLoader] = useState(true);
    const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
    const [crsCompltTrendValuesOfSingle, setCrsCompltTrendValuesOfSingle] = useState([]);
    const [trendFilterCourses, setTrendFilterCourses] = useState([]);
    const [trendFilterCoursesOfSingle, setTrendFilterCoursesOfSingle] = useState([]);
    const [statusFilterData] = useState([
        "Completed",
        "Inprogress",
        "OverDue",
        "Yet to start",
    ]);
    const crsTableRes = useSelector((state) => state.report?.lpTable);
    const crsReaRes = useSelector((state) => state.report?.crsReportRea);
    const crsTrendRes = useSelector((state) => state.report?.crsReportTrend);
    const crsReportTrendOfSingleRes = useSelector((state) => state.report?.crsReportTrendOfSingle);
    const crsStatsRes = useSelector((state) => state.report?.crsReportStats);
    const [profileReports, setProfileReports] = useState(null);
    const [profileReportsFilter, setProfileReportsFilter] = useState([]);
    const [realEstateAgent, setRealEstateAgent] = useState([]);
    const [filterYearData, setFilterYearData] = useState([])
    const [filterYearDataOfSingle, setFilterYearDataOfSingle] = useState([])
    const [legendOfSingle, setLegendOfSingle] = useState([])
    const [seriesOfSingle, setSeriesOfSingle] = useState([])
    const [legendOfAll, setLegendOfAll] = useState([])
    const [seriesOfAll, setSeriesOfAll] = useState([])
    // const [dateRange, setDateRange] = useState({ "start": "", "end": "" })
    const profileReportRes = useSelector((state) => state.report.profileReport);
    const userDetailRes = useSelector((state) => state.user.userBroker);
    const userOtherRes = useSelector((state) => state.user.userOtherRes);
    const d = new Date();
    let year = d.getFullYear();
    const [trendYear, setTrendYear] = useState(year)
    const anyTotalReportRes = useSelector(
        (state) => state.report?.anyTotalReport
    );
    const crsCompletionTrendRes = useSelector(
        (state) => state.report.crsCompletionTrend
    );
    const [currentPage, setCurrentPage] = useState(1);
    const [limitData, setLimitData] = useState();
    const [totalRecord, setTotalRecord] = useState(0);
    const [legends, setLegends] = useState([]);
    const [series, setSeries] = useState([]);
    let PageSize = 20;
    const [counter, setCounter] = useState(1);
    const FILTER_BY = [
        { id: 0, value: "Select" },
        { id: 1, value: "Learning Points" },
        { id: 2, value: "Progress" },
        { id: 3, value: "Learning Hours" },
    ];
    const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
    const [actualCoursesList, setActualCoursesList] = useState([]);
    const [loaderChart, setLoaderChart] = useState(true)
    const [trendLoaderChart, setTrendLoaderChart] = useState(false)
    const [coursesList, setCoursesList] = useState([]);
    const [increment, setIncrement] = useState(1);
    const rea_ids = []
    const manager_ids = []
    const office_ids = []
    const courseList = []
    const providerList = []
    const status = [];
    const assignmentFrom = [];
    const role = [];
    let brokerages= [];
    let user_id = 1;
    let dateRange= {};
    const [selectedOfficeList, setSelectedOfficeList] = useState(
        []
    );
    const [selectedRea] = useState(
        location?.state?.selectedTeamMatesList
    );
    const [selectedCrsList] = useState(
        location?.state?.selectedCourseList)
    const [selectedProviderList, setSelectedProviderList] = useState([])
    const [selectedBrokerageList, setSelectedBrokerageList] = useState([])
    const [selectedCourseList, setSelectedCourseList] = useState([])
    const [selectedManagerCoachList, setSelectedManagerCoachList] = useState([])
    const [selectedTeamMatesList, setSelectedTeamMatesList] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(["completed", "in-progress", "overdue", "not-started"])
    const [officeDetail, setOfficeDetail] = useState({});
    const currentObjData = useState(
        location?.state?.currentReportObj)


    const userDetailIframe = useSelector(state => state.user.userDetailIframe)
    const [userDetails, setUserDetails] = useState({});

    const [check, setCheck] = useState(isCompliance === "0" ? false : true)
    const [checkCompleted, setCheckCompleted] = useState(true)
    const [checkInProgress, setCheckInProgress] = useState(true)
    const [checkOverdue, setCheckOverdue] = useState(true)
    const [checkYetToStart, setCheckYetToStart] = useState(true)

    // new designchanges 1-May-23
    const [isExpand, setIsExpand] = useState(false);

    useEffect(() => { window.scroll(0, 0) })
    useEffect(() => {
        console.log('dateRange: ', dateRange)
    }, [dateRange])

    useEffect(() => {
        console.log('isCompliance: ', isCompliance);
        if (isCompliance === "0") {
            setCheck(false)
        }
    }, [isCompliance])

    useEffect(() => {
        console.log('userDetailRes: ', userDetailRes)
        if (isMobile) {
            if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
                setUserDetails(userDetailIframe?.payload?.payload)
            }
        } else {
            if (!_.isEmpty(userDetailRes?.payload?.payload)) {
                setUserDetails(userDetailRes?.payload?.payload)
            }
        }
    }, [userDetailRes, userDetailIframe, isMobile])

    useEffect(() => {
        console.log('userOtherRes: ', userOtherRes)

        if (!_.isEmpty(userOtherRes)) {
            if (userOtherRes.status === "success") {
                setOfficeDetail(userOtherRes?.payload?.payload)
            }
        }

    }, [userOtherRes])

    useEffect(() => {
        selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
        })
        selectedTeamMatesList.forEach(function (obj) {
            rea_ids.push(obj.user_id);
        })
        selectedManagerCoachList.forEach(function (obj) {
            manager_ids.push(obj.id);
        })
        selectedProviderList.forEach(function (obj) {
            providerList.push(obj.p_id)
        })
        selectedCourseList.forEach(function (obj) {
            if (obj.source === "xsel") {
                courseList.push(obj.course_code)
            } else {
                courseList.push(obj.course_id)
            }
        })
    })

    useEffect(() => {
        setSelectedManagerCoachList([])
    }, [idFrom])

    // COUNT INCREAMENT
    function setCount(counter, setCounter) {
        return setCounter(counter + 1);
    }

    useEffect(() => {
        hitAllFilterApi();
        // setFilterBy(FILTER_BY[0].value);
    }, [dispatch]);
    useEffect(() => {
        hitReaListApi();
    }, [counter])

    useEffect(() => {
        // hitTrendingApi();
        // setFilterBy(FILTER_BY[0].value);
    }, [trendYear]);

    const getStatusArr = () => {
        let statusArr = [];
        if (checkCompleted) {
            statusArr.push('completed');
        }
        if (checkInProgress) {
            statusArr.push('in-progress');
        }
        if (checkOverdue) {
            statusArr.push('overdue');
        }
        if (checkYetToStart) {
            statusArr.push('not-started');
        }
        setSelectedStatus(statusArr)
        return statusArr;
    }

    const hitReaListApi = (callAPI = true) => {
        if (callAPI) {
            getAppliedFilters();
        }
        let statusArr = getStatusArr();
        dispatch(getCrsReportRea({
            module: 'getCourseReportRea',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                rea_ids: [idFrom],
                limit: counter,
                office_ids: office_ids,
                entity_id: courseList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                provider_ids: providerList,
                date_range: dateRange?.start || dateRange?.end ? dateRange : {},
                status: _.isEmpty(status)
                    ? ["completed", "in-progress", "overdue", "not-started"]
                    : status,
                role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
                assigner_role: _.isEmpty(assignmentFrom) ? ["self","manager","broker_admin","api"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
            }
        }))
    }





    const hitTrendingApi = () => {
        setTrendLoaderChart(true);
        let statusArr = getStatusArr();
        dispatch(getCrsReportTrend({
            module: 'getCourseReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: [idFrom],
                entity_id: courseList,
                compliance: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ? dateRange : {},
                status: _.isEmpty(status)
                    ? ["completed", "in-progress", "overdue", "not-started"]
                    : status,
                role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
                assigner_role: _.isEmpty(assignmentFrom) ? ["self","manager","broker_admin","api"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,

            }
        }))
    }

    const getAppliedFilters = () => {
        let selectedFilters = JSON.parse(localStorage.getItem("SELECTED_FILTER"));
        console.log("selected_fil---", selectedFilters?.selectedFilters);
        let filtersApplied = selectedFilters?.selectedFilters;
        filtersApplied.selectedTeamMatesList.forEach(function (obj) {
            rea_ids.push(obj.user_id);
        });
        filtersApplied.selectedOfficeList.forEach(function (obj) {
            office_ids.push(obj.office_id);
        });
        filtersApplied.selectedManagerCoachList.forEach(function (obj) {
            manager_ids.push(obj.id);
        });
        filtersApplied.selectedProviderList.forEach(function (obj) {
            providerList.push(obj.p_id);
        });
        filtersApplied.selectedCourseList.forEach(function (obj) {
            if (obj.source === "xsel") {
                courseList.push(obj.course_code);
            } else {
                courseList.push(obj.course_id);
            }
        });
        // alert(JSON.stringify(filtersApplied.selectedBrokerageList))
        // if (filtersApplied.selectedBrokerageList && 
        //     Array.isArray(filtersApplied.selectedBrokerageList)
        // ) {
        //     // alert(JSON.stringify(filtersApplied))
        //     setSelectedBrokerageList(filtersApplied.selectedBrokerageList)
        // }
        filtersApplied?.selectedBrokerageList?.forEach(function (obj) {
            console.log("data--",obj)
            brokerages.push(obj);
          });
          if(filtersApplied?.dateRange) {
            dateRange.start = filtersApplied?.dateRange?.start;
            dateRange.end = filtersApplied?.dateRange?.end;
        }
        filtersApplied.selectedStatus.forEach(function (obj) {
            status.push(obj);
        });
        filtersApplied.selectedAssignment.forEach(function (obj) {
            assignmentFrom.push(obj);
        });
        filtersApplied.selectedRole.forEach(function (obj) {
            role.push(obj);
        });
        user_id = [];
        if (_.isArray(filtersApplied.selectedAgentStatus)) {
            if (filtersApplied.selectedAgentStatus.includes(3) ||
                (filtersApplied.selectedAgentStatus.includes(1) && filtersApplied.selectedAgentStatus.includes(2))
            ) {
                user_id = 3
            } else if (filtersApplied.selectedAgentStatus.includes(1)) {
                user_id = 1
            } else if (filtersApplied.selectedAgentStatus.includes(2)) {
                user_id = 2
            }
        }
    }

    const hitAllFilterApi = () => {
        // ["","in-progress","not-started"],

        getAppliedFilters();
        let statusArr = getStatusArr();
        dispatch(
            getProfileCompletionReport({
                module: "getCourseProgressReport",
                postData: {
                    token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    limit: counter,
                    rea_ids: [idFrom],
                    entity_id: courseList,  //course_codes
                    office_ids: office_ids,
                    provider_ids: providerList,
                    compliance: check ? 1 : 0,
                    manager_ids: manager_ids,
                    date_range: dateRange?.start || dateRange?.end ? dateRange : {},
                    status: _.isEmpty(status)
                        ? ["completed", "in-progress", "overdue", "not-started"]
                        : status,
                    role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
                    assigner_role: _.isEmpty(assignmentFrom) ? ["self","manager","broker_admin","api"] : assignmentFrom,
                    is_videos: JSON.parse(isVideos),
                    user_status: user_id,
                    brokerage: brokerages,
                },
            })
        );

        dispatch(
            userDetailOther({
                module: "getUserDetailOther",
                postData: {
                    user_id: idFrom,
                },
            })
        );

        hitReaListApi(false);


        // hitTrendingApi();

        // getSingleCompletionTrend(courseList);

        dispatch(getCrsReportStats({
            module: 'getCourseReportStats',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                rea_ids: [idFrom],
                entity_id: courseList,
                compliance: check ? 1 : 0,
                manager_ids: manager_ids,
                provider_ids: providerList,
                date_range: dateRange?.start || dateRange?.end ? dateRange : {},
                status: _.isEmpty(status)
                    ? ["completed", "in-progress", "overdue", "not-started"]
                    : status,
                role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
                assigner_role: _.isEmpty(assignmentFrom) ? ["self","manager","broker_admin","api"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
            }
        }))

    }
    const getSingleCompletionTrend = (courseList) => {
        setIsLoading(true)
        setLoaderChart(true)
        let statusArr = getStatusArr();
        dispatch(getCrsReportTrendOfSingle({
            module: 'getCourseReportTrend',
            postData: {
                token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                office_ids: office_ids,
                entity_id: courseList,
                rea_ids: [idFrom],
                compliance: check ? 1 : 0,
                year: _.toNumber(trendYear),
                manager_ids: manager_ids,
                date_range: dateRange?.start || dateRange?.end ? dateRange : {},
                status: _.isEmpty(status)
                    ? ["completed", "in-progress", "overdue", "not-started"]
                    : status,
                role: _.isEmpty(role) ? ["realtor", "manager", "guest", "all"] : role,
                assigner_role: _.isEmpty(assignmentFrom) ? ["self","manager","broker_admin","api"] : assignmentFrom,
                is_videos: JSON.parse(isVideos),
                user_status: user_id,
                brokerage: brokerages,
            }
        }))
    }

    const searchTable = (searchVal) => {
        let list = _.cloneDeep(profileReportsFilter);
        if (searchVal === "") { setProfileReports(list); return; }

        let filterBySearch = [];
        for (const item of list) {
            if (item?.course_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
                item?.profile_status?.toLowerCase().includes(searchVal.toLowerCase())) {
                filterBySearch.push(item)
            }
        }
        console.log('filterBySearch: ', filterBySearch);

        setProfileReports(filterBySearch);
    }


    useEffect(() => {
        if (!_.isEmpty(profileReportRes)) {
            let legends = [];
            let series = [];
            if (profileReportRes?.status === "success") {
                setIsLoading(false);
                const reportData = profileReportRes?.payload?.payload?.user_data;
                setProfileReports(reportData);
                setProfileReportsFilter(reportData);
                if (statusFilterData.includes("Completed")) {
                    let completedCount = reportData?.filter((data) => data.profile_status === "Completed").length
                    series.push(
                        reportData?.filter((data) => data.profile_status === "Completed").length
                    );
                    legends.push(`Completed (${completedCount})`);
                }
                if (statusFilterData.includes("Inprogress")) {
                    let inprogressCount = reportData?.filter((data) => data.profile_status === "Inprogress").length
                    series.push(
                        reportData?.filter((data) => data.profile_status === "Inprogress").length
                    );
                    legends.push(`In Progress(${inprogressCount})`);
                }
                if (statusFilterData.includes("OverDue")) {
                    let overdueCount = reportData?.filter((data) => data.profile_status === "OverDue").length
                    series.push(
                        reportData?.filter((data) => data.profile_status === "OverDue").length
                    );
                    legends.push(`Overdue(${overdueCount})`);
                }
                if (statusFilterData.includes("Yet to start")) {
                    let notStartedCount = reportData?.filter((data) => data.profile_status === "Yet to start").length
                    series.push(
                        reportData?.filter((data) => data.profile_status === "Yet to start").length
                    );
                    // legends.push(`Yet to start (${notStartedCount})`);
                    legends.push(`Yet to start (${notStartedCount})`);
                }
                setLegends(legends);
                setSeries(series);
                setCurrentPage(1);
            } else {
                setProfileReports([]);
                setCanShow(false);
                setIsLoading(false);
            }
            dispatch(getProfileCompletionReportClear());
        }
    }, [profileReportRes]);

    useEffect(() => {
        if (!_.isEmpty(anyTotalReportRes)) {
            if (anyTotalReportRes.status === "success") {
                setTotalRecord(anyTotalReportRes.payload.payload.length);
            }
            return () => {
                dispatch(getAnyTotalReportClear());
            };
        }
    }, [anyTotalReportRes]);


    useEffect(() => {
        dispatch(
            getCrsReportStatsClear());
    }, [dispatch])

    useEffect(() => {
        setCounter(1)
        setRealEstateAgent([])
        return (() => {
            dispatch(getCrsReportReaClear())
        })
    }, [])
    //LP Rea
    useEffect(() => {
        if (!_.isEmpty(crsReaRes)) {
            setLoadSpin(false)
            if (crsReaRes?.status === "success") {
                let allData = [];
                allData = sortByAlphabetical(crsReaRes?.payload?.payload?.real_estate_agents);
                let realEstateAgents = crsReaRes?.payload?.payload?.real_estate_agents;

                setTotalRea(crsReaRes?.payload?.payload)
                let temparr = _.cloneDeep(realEstateAgent)
                if (counter === 1) {
                    temparr = []
                }
                setReaList([...temparr, ...allData])
                setLimitStatus(crsReaRes?.payload?.payload?.real_estate_agents)
                setRealEstateAgent([...temparr, ...allData]);
                setActualCoursesList([...temparr, ...allData]);
                dispatch(getCrsReportReaClear())
            }
        }
    }, [crsReaRes])

    useEffect(() => {
        return (() => {
            dispatch(getCrsReportTrendClear())
        })
    }, [])
    //Compliance Completion trend
    useEffect(() => {
        if (!_.isEmpty(crsTrendRes)) {
            setImgLoader(false);
            setLoaderChart(false)
            setTrendLoaderChart(false)
            if (crsTrendRes?.status === "success") {
                let allData = []
                allData = crsTrendRes?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                setCrsCompltTrendValues(tempArrTrend)

                // setCrsCompltTrendValues(Object.values(allData));
                setFilterYearData(crsTrendRes?.payload?.payload?.year)
                setTrendFilterCourses(crsTrendRes?.payload?.payload?.courses)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = crsTrendRes?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)
                setLegendOfAll(tempArr)
                setSeriesOfAll(tempArrSeries)

                dispatch(getCrsReportTrendClear())
            }
        }
    }, [crsTrendRes])

    useEffect(() => {
        if (!_.isEmpty(crsReportTrendOfSingleRes)) {
            setImgLoader(false);
            setIsLoading(false);
            setLoaderChart(false)
            if (crsReportTrendOfSingleRes?.status === "success") {
                let allData = []
                allData = crsReportTrendOfSingleRes?.payload?.payload?.completion_trend;
                let trendData = Object.entries(allData) //Object.values(allData)
                let tempArrTrend = [['', 'Percentage']]

                for (const [key, value] of trendData) {
                    tempArrTrend.push([key, value])
                }
                // setCrsCompltTrendValuesOfSingle(tempArrTrend)
                setCrsCompltTrendValuesOfSingle(Object.values(allData));
                setFilterYearDataOfSingle(crsReportTrendOfSingleRes?.payload?.payload?.year)

                let tempArr = [];
                let tempArrSeries = [];
                let legend = crsReportTrendOfSingleRes?.payload?.payload?.legends_data;
                tempArr.push(`Completed (${legend?.completed})`);
                tempArrSeries.push(legend?.completed)
                tempArr.push(`In Progress(${legend?.inprogress})`);
                tempArrSeries.push(legend?.inprogress)
                tempArr.push(`Overdue(${legend?.overdue})`);
                tempArrSeries.push(legend?.overdue)
                tempArr.push(`Yet to start (${legend?.notstarted})`);
                tempArrSeries.push(legend?.notstarted)

                setLegendOfSingle(tempArr)
                setSeriesOfSingle(tempArrSeries)
                dispatch(getCrsReportTrendOfSingleClear())
            }
        }
    }, [crsReportTrendOfSingleRes])

    //Compliance Stats
    useEffect(() => {
        if (!_.isEmpty(crsStatsRes)) {
            if (crsStatsRes?.status === "success") {
                setIsLoaded(false);
                let allData = crsStatsRes?.payload?.payload?.stats;
                setOverAllLearningPoints(allData)
            }
            getCrsReportStatsClear()
        }
    }, [crsStatsRes])

    const currentTableData = useMemo(() => {
        if (profileReports !== null) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            setCanShow(true);
            return profileReports?.slice(firstPageIndex, lastPageIndex);
        }
    }, [currentPage, profileReports]);
    // let min = Math.ceil(overAllLearningPoints?.learning_mins * 60);
    // filtration
    const sortByAlphabetical = (list) => {
        return list?.sort((a, b) => b.learning_points - a.learning_points);
    };
    const sortByProgress = (list) => {
        return list?.sort(
            (a, b) =>
                _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
        );
    };
    const sortByLearningHrs = (list) => {
        return list?.sort(
            (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
        );
    };

    useEffect(() => {
        if (counter > 1)
            sortAfterLoadMore();
    }, [actualCoursesList])

    const sortAfterLoadMore = () => {
        if (filterBy === "Learning Points") {
            const sortedList = sortByAlphabetical(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Progress") {
            const sortedList = sortByProgress(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else if (filterBy === "Learning Hours") {
            const sortedList = sortByLearningHrs(actualCoursesList);
            setRealEstateAgent(sortedList);
        } else {
            setRealEstateAgent(reaList)
        }
    };

    const ExportToExcel = () => {
        const data = _.cloneDeep(profileReports);
        for (let item of data) {

            item.start_date =
                item?.start_date !== undefined && item?.start_date !== ""
                    ? moment(
                        StaticUtils.getDateFromTimeStamp(item?.start_date),
                        "MM/DD/YYYY"
                    ).format("DD MMM, YYYY")
                    : "-";

            item.profile_status =
                item?.profile_status === "Inprogress"
                    ? "In Progress"
                    : item?.profile_status === "Yet to start" || item?.profile_status === "not-started"
                        ? "Yet to start"
                        : item?.profile_status === "OverDue"
                            ? "Overdue"
                            : "Completed";
            item.profile_progress =
                item?.profile_progress !== undefined && item?.profile_progress !== ""
                    ? item?.profile_progress + "%"
                    : "-";
            item.complete_date =
                item?.complete_date !== undefined && item?.complete_date !== ""
                    ? moment(
                        StaticUtils.getDateFromTimeStamp(item?.complete_date),
                        "MM/DD/YYYY"
                    ).format("DD MMM, YYYY")
                    : "-";
        }

        //for sequencing
        let tempArr = [];
        for (const item of data) {
            let obj = {
                "first_name": item.first_name,
                "last_name": item.last_name,
                "email": item.email,
                "start_date": item.start_date,
                "user_manager_name": item.user_manager_name,
                "ofc_location": item.ofc_location,
                "office_name": item.office_name,
                "course_name": item.course_name,
                "profile_status": item.profile_status,
                "profile_progress": item.profile_progress,
                "complete_date": item.complete_date,
            }
            tempArr.push(obj)

        }


        const newThing = [];
        tempArr.map((item) => {
            newThing.push(
                _.mapKeys(item, (value, key) => {
                    switch (key) {
                        case "first_name":
                            return "First Name";
                        case "last_name":
                            return "Last Name";
                        case "email":
                            return "Email";
                        case "start_date":
                            return "Started";
                        case "profile_status":
                            return "Status";
                        case "course_name":
                            return JSON.parse(isVideos) ? "Video Name" : "Course Name";
                        case "profile_progress":
                            return "Progress %";
                        case "complete_date":
                            return "Completed";
                        default:
                            return;
                    }
                })
            );
        });

        for (let i = 0; i < newThing.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete newThing[i].undefined;
        }

        for (let i = 0; i < data.length; i++) {
            // arrayObj[i].stroke = arrayObj[i]['key1'];
            delete data[i]._id;
        }
        // console.log('data:', data)
        // exportFromJSON({ data, fileName, exportType })

        //For mobile
        let tempObj = {
            method: isCompliance === "0" ? "LearningProgressReport" : "ComplianceReport",
            report: newThing,
            isVideos: JSON.parse(isVideos)
        }
        if (window.callbackHandler != undefined) {
            window.callbackHandler.postMessage(JSON.stringify(tempObj));
        } else if (window.webkit != undefined) {
            if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(tempObj));
            }
        }



        const worksheet = XLSX.utils.json_to_sheet(newThing);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        let fileNameNew = check ? "ComplianceReport" : "LearningProgressReport"
        XLSX.writeFile(workbook, fileNameNew + ".xlsx");
    };


    return (
        <>
            <Loader start={isLoading} />
            <section className="reports-header pt-5 pb-2">
                <div className="container reports-head-main-filter">
                    <div className="row">
                        <div className="col-md-12">
                            <button
                                type="button"
                                id="backbtnreport"
                                className="btn btn-primary-complete bckbtn mb-3"
                                onClick={() => {
                                    navigate(-1)
                                }}
                            >
                                Back
                            </button>
                            <div className="reports-head-main">
                                Reports
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="agent-user-detailbox">
                                <div className="agent-img">
                                    <img src={_.isEmpty(officeDetail?.profile_img) ? "/images/avatar.svg" : officeDetail?.profile_img} width="96" height="96" className="img-fluid" alt="" />
                                </div>
                                <div className="agent-detsils d-flex flex-column h-100">
                                    <div className="h-50">
                                        <div class="agent-name-rsp">
                                            {officeDetail?.username}
                                        </div>
                                        <div className="agent-desg">
                                            {officeDetail?.designation}
                                        </div>
                                    </div>
                                    <div className="d-flex h-50 align-items-end">
                                        <div className="applied-filter-agentss">
                                            {officeDetail?.office_name}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-page-title"><strong>{isCompliance === "0" ? "Learning Progress" : "Compliance"}</strong></div>
                </div>
            </section>



            <ReportGraphComponent
                trendYear={trendYear}
                loadChart={loaderChart}
                seriesAll={seriesOfAll}
                legendsAll={legendOfAll}
                trendValues={crsCompltTrendValues}
                listingData={courseList}
                seriesSingle={seriesOfSingle}
                legendsSingle={legendOfSingle}
                trendLoadChart={trendLoaderChart}
                filterYearData={filterYearData}
                trendFilterCourses={trendFilterCourses}
                overAllLearningPoints={overAllLearningPoints}
                trendValueSingle={crsCompltTrendValuesOfSingle}
                setYear={setTrendYear}
                setLoadChart={setLoaderChart}
                setImgLoader={setImgLoader}
                // getCompletionTrend={getSingleCompletionTrend}
                filterYearDataOfSingle={filterYearDataOfSingle}
                isDetail={true}
                check={check}
                ExportToExcel={ExportToExcel}
                courseOrVideo={JSON.parse(isVideos)}
            />

            <div className="container">
                <div className="auto-adjustrow mt-4 d-flex">
                    <div className="col-4-auto">
                        <AgentReportUICardComponent
                            title={'Learning Points'}
                            headerValue={overAllLearningPoints?.learning_points}
                            leftLabel={'This Week'}
                            leftValue={overAllLearningPoints?.week_learning_points}
                            isLeftInnerHTML={false}
                            rightLabel={'From Last Week'}
                            rightValue={overAllLearningPoints?.from_last_week_points_progress}
                            isRightInnerHTML={false}
                        />
                    </div>
                  {!JSON.parse(isVideos) &&  <div className="col-4-auto">
                        <AgentReportUICardComponent
                            title={'Learning Hours'}
                            headerValue={overAllLearningPoints?.learning_hrs_val}
                            leftLabel={'This Week'}
                            leftValue={overAllLearningPoints?.week_learning_hrs}
                            isLeftInnerHTML={true}
                            rightLabel={'From Last Week'}
                            rightValue={overAllLearningPoints?.from_last_week_hrs_progress}
                            isRightInnerHTML={false}
                        />
                    </div> }
                </div>
            </div>
            {/* <div id="myOnboard" class="center_line"></div> */}
            <ProgressReportTableComponentForAgentDetail
                setSearchInput={""}
                getFilteredData={[]}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                isView={isView}
                statusFilterData={statusFilterData}
                setCanShow={setCanShow}
                profileReports={profileReports}
                currentTableData={currentTableData}
                type={type}
                message={"Courses that are assigned to users, will appear here."}
                isCompliance={true}
                searchTable={searchTable}
                fromPage={1}  // 1=course, 2= Learning Path, 3=Onboarding
            />
        </>
    );
};
export default ComplianceReportSectionAgentDetail;
